var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"28","fill":"none","viewBox":"0 0 35 28"}},_vm.$listeners),[_c('path',{attrs:{"stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M34.125 14.053H1M20.765 1l13.36 13.052-13.36 13.054"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }